import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { browserLogger } from '../../loggers/browser';

declare global {
  type AwsWafIntegration = {
    hasToken: () => boolean;
    getToken: () => Promise<string>;
  };

  interface Window {
    AwsWafIntegration?: AwsWafIntegration;
  }
}

const TOKEN_FETCH_MARK_NAME = 'aws_waf_token_fetched';

export const fetchAwsWafToken = async () => {
  if (!window.AwsWafIntegration) {
    recordMark(TOKEN_FETCH_MARK_NAME, {
      success: false,
      reason: 'AwsWafIntegration_not_found',
    });

    // resolve to empty string to allow the request to continue
    return '';
  }

  try {
    const token = await window.AwsWafIntegration.getToken();

    recordMark(TOKEN_FETCH_MARK_NAME, {
      success: true,
    });

    return token;
  } catch (error: unknown) {
    browserLogger({
      level: 'error',
      team: 'client-onboarding',
      message: 'AwsWafIntegration: unable to fetch token',
      context: {
        error,
        feature: 'aws-waf-integration',
      },
    });

    recordMark(TOKEN_FETCH_MARK_NAME, {
      success: false,
      reason: 'token_fetch_error',
    });

    // Resolve to empty string to allow the request to continue
    return '';
  }
};
